module.exports = __webpack_public_path__ + "static/img/xc.4b03152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userVal/xc.png
// module id = eSi1
// module chunks = 0